import { render, staticRenderFns } from "./job-view.vue?vue&type=template&id=5167bfcc&scoped=true&"
import script from "./job-view.vue?vue&type=script&lang=js&"
export * from "./job-view.vue?vue&type=script&lang=js&"
import style0 from "./job-view.vue?vue&type=style&index=0&id=5167bfcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5167bfcc",
  null
  
)

export default component.exports